module.exports = __webpack_public_path__ + "static/media/logo.8dad7a16.png";